import { gsap, ScrollTrigger } from 'gsap/all'
gsap.registerPlugin(ScrollTrigger)

export function collaboration(element: Element): void {
  const image = element.querySelector('.js-image') as HTMLImageElement
  const cards = [...Array.from(element.querySelectorAll('.js-item'))] as HTMLElement[]

  let mm = gsap.matchMedia()

  mm.add('(min-width: 769px) and (orientation: landscape)', () => {
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: element,
        start: 'center-=25% bottom',
        end: 'center bottom'
        // markers: true
      }
    })

    cards.forEach((card, index) => {
      // find odd index with modulo
      const isOdd = index % 2 !== 0

      gsap.set(card, {
        xPercent: isOdd ? 50 : -50,
        autoAlpha: 0
      })
    })

    gsap.set(image, { xPercent: 50, autoAlpha: 0 })

    tl.to(image, { xPercent: 0, autoAlpha: 1, duration: 1, ease: 'expo.inOut' }).to(
      cards,
      { xPercent: 0, duration: 1, ease: 'expo.inOut', stagger: 0.1, autoAlpha: 1 },
      '0'
    )
  })
}
